import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import useFeatureFlags from './useFeatureFlags';

const MAPPING_FIELDS = [
  'maxCloningVoices',
  'maxDevices',
  'maxInstantVoiceCloning',
];
const MAPPING_PACKAGE_FIELDS = ['features', 'maxInstantVoiceCloning'];

const useUserInfo = () => {
  const ttsUserInfo = useSelector((state) => state.user.ttsUser);
  const userId = useSelector((state) => state.auth.user?.id);
  const userPackageCode = useSelector((state) => state.auth.user?.packageCode);
  const studioUsageOptions = useSelector(
    (state) => state.auth.user?.studioUsageOptions,
  );
  const maxCloningVoices = useSelector(
    (state) => state.auth.user?.maxCloningVoices,
  );
  const maxDevices = useSelector((state) => state.auth.user?.maxDevices);
  const maxInstantVoiceCloning = useSelector(
    (state) => state.auth.user?.maxInstantVoiceCloning,
  );

  const { getFeatureValue } = useFeatureFlags();
  const useUsageOptions = getFeatureValue(
    FEATURE_KEYS.USE_USAGE_OPTIONS_IN_PACKAGE,
    { userId, packageCode: userPackageCode },
  );

  const ttsUser = useMemo(() => {
    const usageOptions = studioUsageOptions || {};

    if (useUsageOptions) return { ...ttsUserInfo, ...usageOptions };

    const userFieldValues = {
      maxCloningVoices,
      maxDevices,
      maxInstantVoiceCloning,
    };
    const filteredUserFields = MAPPING_FIELDS.reduce((acc, field) => {
      if (userFieldValues[field] !== undefined) {
        acc[field] = userFieldValues[field];
      }
      return acc;
    }, {});

    const filteredPackageFields = MAPPING_PACKAGE_FIELDS.reduce(
      (acc, field) => {
        if (usageOptions?.[field] !== undefined)
          acc[field] = usageOptions[field];

        return acc;
      },
      {},
    );
    return { ...ttsUserInfo, ...filteredUserFields, ...filteredPackageFields };
  }, [
    ttsUserInfo,
    useUsageOptions,
    studioUsageOptions,
    maxCloningVoices,
    maxDevices,
    maxInstantVoiceCloning,
  ]);

  return { ttsUser };
};
export default useUserInfo;
